import { __assign } from "tslib";
import * as React from 'react';
import { CnForm as PCCnForm, CnFormField as PCCnFormField, } from '@cainiaofe/cn-ui';
import { componentMap } from '../../form-component-map/index';
import { CnFormArrayCard } from './cn-form-array-card';
export var CnForm = function (props) {
    return (React.createElement(PCCnForm, __assign({}, props, { components: __assign(__assign(__assign({}, props.components), componentMap), { CnFormArrayCard: CnFormArrayCard }) })));
};
export var CnFormField = function (props) {
    return React.createElement(PCCnFormField, __assign({}, props));
};
export { formilyCore, formilyReact } from '@cainiaofe/cn-ui';
